module.exports = __webpack_public_path__ + "static/media/gbuffer.a4bb2028.vert";